import { useEffect } from 'react';
import { navigate } from 'gatsby';

const useGatePage = (currentSlug: string | undefined, gateContentSlug:string) => {
  useEffect(() => {
    const isGatePassed = (pageSlug: string | undefined) => {
      const currentSessionPageSlug = sessionStorage.getItem('currentSessionPageSlug');
      return currentSessionPageSlug === pageSlug;
    };

    const result = isGatePassed(currentSlug);

    if (!result && gateContentSlug && currentSlug) {
      navigate(`/${gateContentSlug}?redirect=${currentSlug}`);
    }
  }, [currentSlug, gateContentSlug]);
};

export default useGatePage;
